/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFilmStrip = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m13.275 11.171 7 2.033a1.024 1.024 0 0 1 .28 1.824l-1.985 1.345 3.137 3.19L20.293 21l-3.137-3.19-1.324 2.019a.995.995 0 0 1-.986.44 1.003 1.003 0 0 1-.807-.726l-2-7.115a1.024 1.024 0 0 1 .254-.998.993.993 0 0 1 .982-.259zm-6.568.044 3.707 3.768-3.707 3.769-1.414-1.438L6.585 16H2v-2h4.618l-1.325-1.347zm7.75 2.414.911 3.243.8-1.221a1.01 1.01 0 0 1 .277-.282l1.201-.814zM8 3v6H2V3zm7 0v6H9V3zm7 0v6h-6V3zM6 5H4v2h2zm7 0h-2v2h2zm7-.066h-2V7h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgFilmStrip as FilmStrip };
